import React, { Component } from 'react'
import { Field, reduxForm } from "redux-form"
import { connect } from "react-redux"
import { Col, Row, FormControl } from 'react-bootstrap'
import { getAddressData } from '../utils'
// import AddressFormTypeahead from 'react-thailand-address-typeahead'

class ComponentAddress extends Component {

    state = {
        provinces: [],
        amphoes: [],
        districts: [],
        province: '',
        amphoe: '',
        district: '',
    }

    componentWillMount() {
        let addressData = getAddressData()
        let Provinces = []
        addressData.map(comb => {
            Provinces.includes(comb.province) ? '' : Provinces.push(comb.province)
        })
        this.setState({ provinces: Provinces })
    }

    isAmphoeInProvince(value) {
        return value.province == this.state.province
    }

    isDistinctInAmphoe(value) {
        return value.amphoe == this.state.amphoe
    }

    getZipcode(district) {
        let addressData = getAddressData()
        let result = addressData.filter((value) => {
            if (district) {
                return value.district == district
            } else {
                return value.district == this.state.district
            }
        })
        return result[0] ? result[0].zipcode : 'กรุณาเลือกแขวงก่อน'
    }

    renderField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <label>{field.placeholder}</label>
                <input placeholder={field.placeholder} className="form-control" type={field.type} {...field.input} />
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }

    renderDropdownField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <label>{field.placeholder}</label>
                <FormControl componentClass="select" defaultValue='' {...field.input}>
                    <option key={0} style={{ display: 'none' }} disabled value='' >เลือกจังหวัด</option>
                    {this.renderProvinces()}
                </FormControl>
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }

    renderProvinces() {
        let id = 1
        let count = 0
        let arrayPerimeter = ['กรุงเทพมหานคร', 'นครปฐม', 'นนทบุรี', 'ปทุมธานี', 'สมุทรปราการ', 'สมุทรสาคร']
        return this.state.provinces.map(dropdown => {
            if (arrayPerimeter.includes(dropdown)) {
                return (
                    <option key={id++} value={dropdown} >{dropdown}</option>
                )
            }
        })
    }

    renderAmphoes() {
        let id = 1
        let count = 0
        let addressData = getAddressData()
        let Amphoes = []

        let Amphoes_temp = addressData.filter(this.isAmphoeInProvince.bind(this))
        Amphoes_temp.map(comb => {
            Amphoes.includes(comb.amphoe) ? '' : Amphoes.push(comb.amphoe)
        })

        return Amphoes.map(dropdown => {
            return (
                <option key={id++} value={dropdown} >{dropdown}</option>
            )
        })
    }

    renderDistricts() {
        let id = 1
        let count = 0
        let addressData = getAddressData()
        let Districts = []
        let Districts_temp = addressData.filter(this.isDistinctInAmphoe.bind(this))
        Districts_temp.map(comb => {
            Districts.includes(comb.district) ? '' : Districts.push(comb.district)
        })

        return Districts.map(dropdown => {
            return (
                <option key={id++} value={dropdown} >{dropdown}</option>
            )
        })
    }

    render() {
        return (
            <div>
                <Row>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="ประเภทที่อยู่อาศัย*"
                            name="residential_type"
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="อาคาร/หมู่บ้าน"
                            name="building"
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="เลขที่*"
                            name="house_number"
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="ห้อง"
                            name="room_number"
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="ชั้น"
                            name="floor"
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="ถนน"
                            name="road"
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="ซอย"
                            name='alley'
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <div className='form-group'>
                            <label>จังหวัด*</label>
                            <FormControl componentClass="select" defaultValue=''
                                onChange={e => {
                                    this.setState({ province: e.target.value, amphoe: '', district: '' });
                                    this.props.setRegisterPageState({ province: e.target.value, amphoe: '', district: '', zipcode: '' })
                                }}
                                value={this.state.province}
                            >
                                <option key={0} style={{ display: 'none' }} disabled value='' >เลือกจังหวัด</option>
                                {this.renderProvinces()}
                            </FormControl>
                        </div>
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <div className='form-group'>
                            <label>เขต*</label>
                            <FormControl componentClass="select" defaultValue=''
                                onChange={e => {
                                    this.setState({ amphoe: e.target.value, district: '' });
                                    this.props.setRegisterPageState({ amphoe: e.target.value, district: '', zipcode: '' })
                                }}
                                value={this.state.amphoe}
                            >
                                <option key={0} style={{ display: 'none' }} disabled value='' >เลือกเขต</option>
                                {this.renderAmphoes()}
                            </FormControl>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col md={4} sm={4} xs={12}>
                        <div className='form-group'>
                            <label>แขวง*</label>
                            <FormControl componentClass="select" defaultValue=''
                                onChange={e => {
                                    this.setState({ district: e.target.value });
                                    this.props.setRegisterPageState({ district: e.target.value, zipcode: this.getZipcode(e.target.value) })
                                }}
                                value={this.state.district}
                            >
                                <option key={0} style={{ display: 'none' }} disabled value='' >เลือกแขวง</option>
                                {this.renderDistricts()}
                            </FormControl>
                        </div>
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <div className='form-group'>
                            <label>รหัสไปรษณีย์*</label>
                            <input className='form-control' disabled value={this.getZipcode()} />
                        </div>
                    </Col>
                    <Col md={4} sm={4} xs={12}>
                        <Field
                            placeholder="จุดสังเกต"
                            name="landmark"
                            type='text'
                            component={this.renderField}
                        />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default ComponentAddress


// WEBPACK FOOTER //
// ./src/components/component_address.js